export const FAQ_ITEMS = [
  {
    q: "Five Star diğer dating uygulamalarından nasıl farklı?",
    a: "Five Star sonsuz kaydırmaya dayalı bir profil kataloğu sunmaz. Her turda senin için özenle seçilen beş profilden oluşan The Five'ı keşfedersin; süreç boyunca çöpçatan desteği alır ve geri bildirimlerinle sonraki seçimlerin şekillenmesine katkıda bulunursun.",
  },
  {
    q: "Swipe var mı?",
    a: "Hayır. Five Star'da amaç sana mümkün olduğunca çok profil göstermek değil; sana özel seçilen kişileri gerçekten değerlendirebilmen için alan açmak. Swipe değil, seçim.",
  },
  {
    q: "The Five nedir?",
    a: "The Five, her turda karşına çıkan ve senin için özenle seçilen beş profilden oluşan seçkidir. Rastgele oluşturulmuş bir liste değildir; tercihlerin ve geri bildirimlerin dikkate alınarak hazırlanır.",
  },
  {
    q: "My Date nedir?",
    a: "My Date, ilgilendiğin kişiye gönderebileceğin bir ilgi isteğidir. İlgi karşılıklı olduğunda ikinize özel eşleşme alanınız açılır ve iletişim kurabilirsiniz.",
  },
  {
    q: "Eşleşme garantisi var mı?",
    a: "Hayır. Five Star daha özenli, daha kişisel bir tanışma süreci sunar; ancak eşleşme ya da ilişki garantisi vermez. Süreç, seçimlerin ve geri bildirimlerinle şekillenir.",
  },
  {
    q: "Üyeliğimi nasıl yönetebilirim?",
    a: "Üyeliğin App Store üzerinden yönetilir. Aboneliğini Apple ID → Abonelikler bölümünden görüntüleyebilir, değiştirebilir veya iptal edebilirsin.",
  },
  {
    q: "Aboneliğimi iptal edersem ne olur?",
    a: "Aboneliğini iptal ettiğinde, ödemesi yapılmış dönemin sonuna kadar üyelik özelliklerini kullanmaya devam edebilirsin; abonelik bir sonraki dönemde yenilenmez.",
  },
  {
    q: "Hesabımı nasıl silebilirim?",
    a: "Uygulama içinde Ayarlar → Hesabımı Sil adımlarını izleyerek hesabını silebilirsin. Ayrıntılı adımlar için Hesap Silme sayfamıza göz atabilirsin.",
  },
  {
    q: "Bir kullanıcıyı nasıl bildirebilirim?",
    a: "Uygunsuz davranışları uygulama içindeki bildirme özelliğiyle bize iletebilirsin. Bildirimler incelenir ve gerekli işlemler uygulanır.",
  },
  {
    q: "Verilerim nasıl kullanılıyor?",
    a: "Verilerin, Gizlilik Politikası'nda açıklanan kapsamda işlenir. Ayrıntılar için Gizlilik sayfamızı inceleyebilir veya privacy@meetfivestar.app adresine yazabilirsin.",
  },
];
